import SubscriptionProjection from 'components/subscriptionProjection';

const SubscriptionProjectionPage = () => {
  return <SubscriptionProjection />;
};

export default SubscriptionProjectionPage;
